import { html } from 'lit';

export const iconCheckmarkCircle = html`
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M0 8.53638C0 4.13013 3.5625 0.536377 8 0.536377C12.4062 0.536377 16 4.13013 16 8.53638C16 12.9739 12.4062 16.5364 8 16.5364C3.5625 16.5364 0 12.9739 0 8.53638ZM11.5938 7.16138C11.9375 6.81763 11.9375 6.28638 11.5938 5.94263C11.25 5.59888 10.7188 5.59888 10.375 5.94263L7 9.31763L5.59375 7.94263C5.25 7.59888 4.71875 7.59888 4.375 7.94263C4.03125 8.28638 4.03125 8.81763 4.375 9.16138L6.375 11.1614C6.71875 11.5051 7.25 11.5051 7.59375 11.1614L11.5938 7.16138Z"
      fill="currentColor"
    />
  </svg>
`;
